import React from "react";
import { connect } from "react-redux";
import MenuSection from "./MenuSection";
import MenuItemSeparator from "./MenuItemSeparator";
import MenuItem from "./MenuItem";

class MenuList extends React.Component {
  hasPermission = (requiredRoles, userGroupId) => {
    if (!requiredRoles || requiredRoles.length === 0) {
      return true;
    }
    return requiredRoles.includes(userGroupId);
  };

  filterMenuItems = (items) => {
    const { user } = this.props;
    const userGroupId = user?.adm_id_admin_group;

    return items
      .filter((item) => this.hasPermission(item.requiredRoles, userGroupId))
      .map((item) => {
        if (item.submenu) {
          const filteredSubmenu = item.submenu.filter((subItem) =>
            this.hasPermission(subItem.requiredRoles, userGroupId)
          );

          return {
            ...item,
            submenu: filteredSubmenu,
          };
        }
        return item;
      })
      .filter((item) => !item.submenu || item.submenu.length > 0);
  };

  render() {
    const { currentUrl, menuConfig, layoutConfig } = this.props;
    const filteredItems = this.filterMenuItems(menuConfig.aside.items);

    return filteredItems.map((child, index) => {
      return (
        <React.Fragment key={`menuList${index}`}>
          {child.section && <MenuSection item={child} />}
          {child.separator && <MenuItemSeparator item={child} />}
          {child.title && (
            <MenuItem
              item={child}
              currentUrl={currentUrl}
              layoutConfig={layoutConfig}
            />
          )}
        </React.Fragment>
      );
    });
  }
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(MenuList);
